import { initializeCardSlider } from '../../../shared/services-slider';

export default function (formEl) {
  const state = {
    currentServiceSelected: 0,
    timeoutID: null,
  };

  const cardSliderOptions = {
    gap: 30,
    slideWidth: 190,
    peek: {
      before: 15,
      after: 15,
    },
    rewind: false,
  };

  // Element to which Glide will be mounted
  const servicesSliderSelector =
    '.pricing-transparency-hero__price-section.glide';

  // Selects all service cards
  const serviceCards = document.querySelectorAll(
    '.price-section-services__service-card',
  );

  // Since the dynamic price locator card also has a .price__card class, I'm selecting
  // based off the data attribute
  const priceCards = document.querySelectorAll('[data-card-for-service]');

  // Glide Controls
  const leftButton = document.querySelector(
    '.price-section-services__control[data-glide-dir="<"]',
  );
  const rightButton = document.querySelector(
    '.price-section-services__control[data-glide-dir=">"]',
  );

  if (serviceCards.length === 4) {
    leftButton.classList.add('hidden');
    rightButton.classList.add('hidden');
  }

  // Price headline
  const priceHeadline = document.querySelector('.price__header');

  // The left button should always be disabled on load
  if (leftButton) {
    leftButton.setAttribute('disabled', '');
  }

  /**
   * Updates currentServiceSelected in state and ensures it's stored as an integer
   *
   * @param id - ID of selected service
   * @returns void
   */
  const updateSelectedService = (id) => {
    state.currentServiceSelected = parseInt(id);
  };

  /**
   * Fetches currently-selected service ID from state
   *
   * @returns string
   */
  const getCurrentServiceID = () => {
    return state.currentServiceSelected;
  };

  /**
   * Activates service button
   *
   * @param element
   * @returns void
   */
  const toggleActivatedClass = (element) => {
    // First find an activated card, if it exists, then remove the is-active class
    const activeEl = document.querySelector('.is-active');
    if (activeEl) activeEl.classList.remove('is-active');

    // Then add the class to the target element
    element.classList.toggle('is-active');
  };

  /**
   * Hides all static price cards
   *
   * @returns void
   */
  const hidePriceCards = () => {
    priceCards.forEach((card) => {
      // To avoid adding multiple "hidden" classes, begin by removing existing classes
      card.classList.remove('hidden');

      // Add .hidden class to all cards
      card.classList.add('hidden');
    });
  };

  /**
   * Ticks number from 0 to n
   */

  const tickPrices = (element, startingPrice, targetPrice, delay) => {
    if (startingPrice === targetPrice) return;

    let timeoutID = setTimeout(() => {
      state.timeoutID = timeoutID;
      element.innerHTML = `$${startingPrice}<sup>*</sup>`;
      tickPrices(element, startingPrice + 1, targetPrice, delay);
    }, delay);
  };

  /**
   * Renders price cards based off service ID
   *
   * @returns void
   */

  const renderPriceCards = () => {
    clearTimeout(state.timeoutID);

    // Convert price cards to array
    const cardsArray = Array.from(priceCards);

    // Find respective service price cards based off ID
    const cardsToRender = cardsArray.filter((card) => {
      return (
        parseInt(card.dataset.cardForService) === state.currentServiceSelected
      );
    });

    // Hide all price cards
    hidePriceCards();

    // Render respective cards
    cardsToRender.forEach((card) => {
      // Target element responsible for rendering price
      let priceEl = card.children[1];

      // Grab the price and parse it as an integer
      let targetPrice = parseInt(card.dataset.cardPrice.split('$')[1]);

      card.classList.remove('hidden');

      // Count up
      tickPrices(priceEl, 0, targetPrice, 0);
    });
  };

  /**
   * Updates the price section headline with the service's display name
   *
   * @param displayName - Service's display name
   * @returns  void
   */

  const updatePriceSectionHeadline = (displayName) => {
    const priceHeadlineTemplate = (staticCopy, displayName) =>
      `${staticCopy[0]}${displayName}`;
    priceHeadline.innerHTML = priceHeadlineTemplate`Self-pay prices for ${displayName}`;
  };

  /**
   * Updates value attribute on price locator's hidden input
   * @param serviceID - Selected service's ID
   */

  const updateLocatorHiddenInput = (serviceID) => {
    const priceSearchForm = document.querySelector('[data-price-search-form]');
    const priceLocatorHiddenInput = priceSearchForm.querySelector(
      '[data-price-search-service-value]',
    );
    priceLocatorHiddenInput.value = serviceID;
  };

  initializeCardSlider(
    servicesSliderSelector,
    cardSliderOptions,
    (glide, Sizes) => {
      let currentIndex = 0;
      let clickedCardIndex = 0;
      // Register click listeners
      serviceCards.forEach((card) => {
        card.addEventListener('click', ({ currentTarget }) => {
          // This gets the index of the clicked element in the serviceCards collection to later
          // pass into glide.go()
          const currentTargetIndex =
            Array.from(serviceCards).indexOf(currentTarget);
          const id = currentTarget.dataset.serviceId;
          const currentServiceID = getCurrentServiceID();
          // the glide.disabled attribute does not work here
          if (window.innerWidth >= 1000) {
            console.log('disabled');
            if (id === currentServiceID) return;

            updateSelectedService(id);
            toggleActivatedClass(currentTarget);
            renderPriceCards();
            updatePriceSectionHeadline(currentTarget.dataset.displayName);
            updateLocatorHiddenInput(id);

            if (formEl.dataset.submitted) {
              formEl.dispatchEvent(new Event('submit'));
            }
          } else {
            clickedCardIndex = currentTargetIndex;
            currentIndex = glide.index;
          }
        });
      });

      glide.on('swipe.start', () => {
        const activeCard = serviceCards[glide.index];
        if (activeCard.classList.contains('is-active'))
          activeCard.classList.remove('is-active');
      });

      glide.on('move.after', () => {
        if (currentIndex === glide.index && clickedCardIndex !== glide.index) {
          glide.go(`=${clickedCardIndex}`);
          currentIndex = clickedCardIndex;
        }
      });

      glide.on('run.after', (move) => {
        const { index } = glide;
        const focusedCard = serviceCards[index];
        toggleActivatedClass(focusedCard);
        const focusedCardServiceID = focusedCard.dataset.serviceId;

        // const cardsToRight = typeof serviceCards[index + 4] !== 'undefined';
        // const cardsToLeft = typeof serviceCards[index - 1] !== 'undefined';

        updateSelectedService(focusedCardServiceID);
        renderPriceCards();
        updatePriceSectionHeadline(focusedCard.dataset.displayName);
        updateLocatorHiddenInput(focusedCardServiceID);
        if (formEl.dataset.submitted) {
          formEl.dispatchEvent(new Event('submit'));
        }

        // leftButton.disabled = !cardsToLeft;
        // rightButton.disabled = !cardsToRight;
      });

      glide.on(['mount.after', 'resize'], () => {
        const { innerWidth } = window;
        if (innerWidth >= 1000) {
          if (!glide.disabled) {
            glide.disable();
          }
        } else {
          glide.enable();
        }
      });
      glide.disable();
      glide.mount({ Sizes });
    },
  );
}
